$(document).ready(function() {
    /** SEND SMS **/
    $('.js-sms').on('click', function (e) {
        e.preventDefault();
        var _this = $(this);
        $.ajax({
            url: _this.attr('data-url'),
            method: "post",
            dataType: "json",
            data: {
                phone: $('.js-tel').val(),
                _token: $('[name="_token"]').val(),
                "g-recaptcha-response": $('#g-recaptcha-response').val()
            },
            success: function (data) {
                if (data.success === true) {
                    $('.confirmation-sms').show(100);
                }
                $('#modal1').find('.window-open__heading').html(data.message);
                $('#modal1').fancybox().trigger('click');
            },
            error: function (error) {
                console.log(error);
            }
        });
    });

    $('.js-confirmation-sms').on('click', function (e) {
        e.preventDefault();
        var _this = $(this);
        _this.closest('.js_validate').find('.new-password .form__item').removeClass('error');
        $.ajax({
            url: _this.attr('data-url'),
            method: "post",
            dataType: "json",
            data: {
                phone: $('.js-tel').val(),
                confirmation_sms: $('[name="confirmation_sms"]').val(),
                _token: $('[name="_token"]').val()
            },
            success: function (data) {
                if (data.success === true) {
                    $('.new-password').show(100);
                }
                $('#modal1').find('.window-open__heading').html(data.message);
                $('#modal1').fancybox().trigger('click');
            },
            error: function (error) {
                console.log(error);
            }
        });
    });

    $.fancybox.defaults.touch = false;
});


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/password-recovery/index.js